import { createContext } from "react";
import PriorReviewSummaryStore from "./PriorReviewSummaryStore";
import CommonStore from "./CommonStore";
import ModalStore from "./ModalStore";
import UserStore from "./UserStore";
import RequestStore from "./RequestStore";
import RequestNoteStore from "./RequestNoteStore";
import RequestReviewNoteStore from "./RequestReviewNoteStore";
import RequestReviewDocumentNoteStore from "./RequestReviewDocumentNoteStore";
import RequestReviewDocumentStore from "./RequestReviewDocumentStore";
import RequestReviewDocumentAnswerStore from "./RequestReviewDocumentAnswerStore";
import RequestReviewStore from "./RequestReviewStore";
import RequestReviewUnlockStore from "./RequestReviewUnlockStore";
import RequestReviewDocumentQuestionStore from "./RequestReviewDocumentQuestionStore";
import AdminSettingStore from "./AdminSettingStore";
import AdminQuestionStore from "./AdminQuestionStore";
import AdminDocumentStore from "./AdminDocumentStore";
import AdminDocumentQuestionStore from "./AdminDocumentQuestionStore";
import SelfTestStore from "./SelfTestStore";

export class RootStore {
    adminSettingStore: AdminSettingStore;
    adminQuestionStore: AdminQuestionStore;
    adminDocumentStore: AdminDocumentStore;
    adminDocumentQuestionStore: AdminDocumentQuestionStore;
    priorReviewSummaryStore: PriorReviewSummaryStore;
    requestStore: RequestStore;
    requestNoteStore: RequestNoteStore;
    requestReviewNoteStore: RequestReviewNoteStore;
    requestReviewDocumentNoteStore: RequestReviewDocumentNoteStore;
    requestReviewDocumentStore: RequestReviewDocumentStore;
    requestReviewDocumentAnswerStore: RequestReviewDocumentAnswerStore;
    requestReviewDocumentQuestionStore: RequestReviewDocumentQuestionStore;
    requestReviewStore: RequestReviewStore;
    requestReviewUnlockStore: RequestReviewUnlockStore;
    selfTestStore: SelfTestStore;
    userStore: UserStore;
    commonStore: CommonStore;
    modalStore: ModalStore;
    constructor() {
        this.adminSettingStore = new AdminSettingStore(this);
        this.adminQuestionStore = new AdminQuestionStore(this);
        this.adminDocumentStore = new AdminDocumentStore(this);
        this.adminDocumentQuestionStore = new AdminDocumentQuestionStore(this);
        this.priorReviewSummaryStore = new PriorReviewSummaryStore(this);
        this.requestStore = new RequestStore(this);
        this.requestNoteStore = new RequestNoteStore(this);
        this.requestReviewNoteStore = new RequestReviewNoteStore(this);
        this.requestReviewDocumentNoteStore = new RequestReviewDocumentNoteStore(this);
        this.requestReviewDocumentStore = new RequestReviewDocumentStore(this);
        this.requestReviewDocumentAnswerStore = new RequestReviewDocumentAnswerStore(this);
        this.requestReviewDocumentQuestionStore = new RequestReviewDocumentQuestionStore(this);
        this.requestReviewStore = new RequestReviewStore(this);
        this.requestReviewUnlockStore = new RequestReviewUnlockStore(this);
        this.selfTestStore = new SelfTestStore(this);
        this.userStore = new UserStore(this);
        this.commonStore = new CommonStore(this);
        this.modalStore = new ModalStore(this);
    }
}

export const RootStoreContext = createContext(new RootStore());